import { render, staticRenderFns } from "./CoursesAdd.vue?vue&type=template&id=3b970b5b"
import script from "./CoursesAdd.vue?vue&type=script&lang=js"
export * from "./CoursesAdd.vue?vue&type=script&lang=js"
import style0 from "./CoursesAdd.vue?vue&type=style&index=0&id=3b970b5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports